import { useToastStore } from '@store/useToastStore'
import './Toast.scss'

function Toast({ id, message, type }) {
  const removeToast = useToastStore((s) => s.removeToast)

  return (
    <div className={`toast toast--${type}`} role="alert">
      <span className="toast-msg">{message}</span>
      <button className="toast-close" onClick={() => removeToast(id)} aria-label="Închide">
        ✕
      </button>
    </div>
  )
}

export default function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts)

  if (toasts.length === 0) return null

  return (
    <div className="toast-container" aria-live="polite">
      {toasts.map((t) => (
        <Toast key={t.id} {...t} />
      ))}
    </div>
  )
}
